import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginatorModel } from 'symbols';
import { MasterModel } from '../states/masters/masters.model';

@Injectable()
export class MastersService {
  readonly api = '/api/masters';

  constructor(private http: HttpClient) {
  }

  getMasters(searchText: string, maxLimit = 20): Observable<PaginatorModel<MasterModel>> {
    return this.http.get<PaginatorModel<MasterModel>>(this.api, { params: { search: searchText, limit: maxLimit } });
  }
}
